import React, { useEffect, useState } from 'react';
import brand_01 from '../assets/brand_01.png';
import useToken from '../context/useToken';
import axios from 'axios';
import { BASE_URL } from '../utils';

const Brands = () => {
  const token = useToken();
  const [brands, setBrands] = useState([]);
  const fetchBrands = async () => {
    try {
      const response = await axios.get(`${BASE_URL}brand`, {
        headers: {
          accept: '*/*',
        },
      });
      setBrands(response.data); // Assuming response.data is an array of brands with an `id` and `src` property
    } catch (error) {
      console.error('Error fetching brands:', error);
    }
  };

  // UseEffect to fetch brands on component mount
  useEffect(() => {
    fetchBrands();
  }, [token]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newBrandSrc, setNewBrandSrc] = useState('');

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${BASE_URL}brand/${id}`, {
        headers: {
          'accept': '*/*',
          'Authorization': `Bearer ${token}`, // Use your token from `useToken`
        },
      });
  
      // Update the brands list after successful deletion
      fetchBrands()
      setBrands(brands.filter((brand) => brand.id !== id));
    } catch (error) {
      console.error('Error deleting brand:', error);
    }
  };

  const handleAddBrand = async () => {
    try {
      const formData = new FormData();
      formData.append('brandLogo', newBrandSrc);
  
      const response = await axios.post('https://thecfagroup.org/v1/api/brand', formData, {
        headers: {
          'accept': '*/*',
          'Authorization': `Bearer ${token}`, // Use your token from `useToken`
          'Content-Type': 'multipart/form-data',
        },
      });
  
      // Assuming the API response includes the new brand with its ID and logo URL
      const newBrand = { id: response.data.id, src: response.data.brandLogo };
      setBrands([...brands, newBrand]);
      setIsModalOpen(false);
      setNewBrandSrc('');
      fetchBrands()
    } catch (error) {
      console.error('Error uploading brand logo:', error);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewBrandSrc(file); // Store the file for API upload
    }
  };
  

  return (
    <div className="py-[5rem] w-[80%] mx-auto">
      <div className="flex flex-wrap justify-center gap-[6rem] md:w-[85vw] mx-auto">
        {brands.map((brand) => (
          <div key={brand._id} className="relative">
            <img
              src={brand.brandLogo}
              alt={`brandImg-${brand._id}`}
              className="w-2.5/4 max-h-[110px] max-w-[150px] object-contain opacity-70 cursor-pointer hover:scale-110 hover:opacity-100 transition-transform duration-300"
            />
            {/* Delete icon positioned at the top-right */}
            {token && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="absolute top-[-10px] right-[-10px] h-6 w-6 border border-black bg-black rounded-full text-white cursor-pointer"
                onClick={() => handleDelete(brand._id)}
              >
                <path
                  fillRule="evenodd"
                  d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </div>
        ))}
      </div>

      {token && (
        <div className="flex justify-center mt-8">
          <button
            onClick={() => setIsModalOpen(true)}
            className="bg-[#25a182] text-white px-6 py-3 rounded-lg shadow-lg hover:bg-white hover:text-[#25a182] border border-[#25a182] transition-transform duration-300 transform hover:scale-105"
          >
            Add Brand
          </button>
        </div>
      )}

      {/* Modal for adding a new brand */}
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full">
            <h2 className="text-2xl font-bold mb-4">Add a new brand</h2>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange} // Handle file input change
              className="w-full p-2 border border-gray-300 rounded mb-4"
            />
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setIsModalOpen(false)}
                className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={handleAddBrand}
                className="bg-[#25a182] text-white px-4 py-2 rounded hover:bg-[#1f8e6d]"
              >
                Add Brand
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Brands;
